// extracted by mini-css-extract-plugin
export default {"serviceNav":"service-nav_serviceNav__iior6","wrapper":"service-nav_wrapper__FXoHv"};